import { render, staticRenderFns } from "./ViewJobPage.vue?vue&type=template&id=4f688afa&scoped=true&"
import script from "./ViewJobPage.vue?vue&type=script&lang=js&"
export * from "./ViewJobPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewJobPage.vue?vue&type=style&index=0&id=4f688afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f688afa",
  null
  
)

export default component.exports